import { Type } from '@angular/core';
import { SproutIconComponent } from './sprout-icon.component';
import { BasketIconComponent } from './basket-icon.component';
import { WindIconComponent } from './wind-icon.component';
import { SnowflakeIconComponent } from './snowflake-icon.component';
import { ClockIconComponent } from './clock-icon.component';
import { DropletIconComponent } from './droplet-icon.component';
import { SunIconComponent } from './sun-icon.component';
import { TriangleAlertIconComponent } from './triangle-alert-icon.component';
import { LeafIcon } from './leaf-icon';

/**
 * Les pictogrammes au trait que des données nomment (pastille d'un ton,
 * signal d'un message du jour) : le nom choisit le composant d'icône, rendu
 * avec `*ngComponentOutlet`. Les icônes restent celles de `@icons`.
 */
export type LineIconName = 'sprout' | 'basket' | 'wind' | 'snowflake' | 'clock' | 'droplet' | 'sun' | 'leaf' | 'alert';

export const LINE_ICONS: Record<LineIconName, Type<unknown>> = {
  sprout: SproutIconComponent,
  basket: BasketIconComponent,
  wind: WindIconComponent,
  snowflake: SnowflakeIconComponent,
  clock: ClockIconComponent,
  droplet: DropletIconComponent,
  sun: SunIconComponent,
  leaf: LeafIcon,
  alert: TriangleAlertIconComponent,
};
